import React, { useCallback, useEffect, useRef, useState } from 'react';
import api from '../../services/api';
import { useLocation } from 'react-router-dom';
import * as FeatherIcon from 'react-feather';
import { useUser } from '../../context/UserContext';
import useAuth from '../../hooks/useAuth';
import { getUserStatsObject, recordActivity } from '../../services/commonService';
import { getCheckoutClientInfo } from '../../services/authService';
import useDebounce from '../Frontend/uiUtils/useDebounce';
import "./SearchV2.css"

const SearchBoxV2 = () => {
  useAuth();
  const { user } = useUser();
  const currentUrl = useLocation().pathname;
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const wrapperRef = useRef(null);

  // Use the useDebounce hook to debounce the query value
  const debouncedQuery = useDebounce(query, 300);

  const fetchSuggestions = useCallback(async (value) => {
    if (value.length > 0) {
      let page = "";
      let type = "";
      if(currentUrl == "/dashboard"){
        type = page = "Dashboard";
      }else if(currentUrl == "/clients_accounts"){
        type = page = "Companies";
      }
      const userStat = getUserStatsObject(type, "search", "Data: "+value+", Page Source: "+page, currentUrl);
      recordActivity(userStat);

      let search_params = {
        account_name : value,
      }

      if(user.role_key === 'CLIENT' || user.role_key === 'CLIENT_EMPLOYEE' || user.role_key === 'SALES_DEMO' || user.role_key === 'ANALYST'){

        const {checkoutClientId, checkoutClientName} = getCheckoutClientInfo();

        const clientCode = checkoutClientId || (user?.company_id || '');

        search_params.client_code = clientCode;
      }

      try {
        const response = await api.get('/accounts/get_accounts', {
          params: search_params,
        });
        const list = response.data.result?.list || [];
        const accountNames = list.map(item => ({
          id: item.id,
          account_name: item.account_name,
          client_name: item.client_name
        }));
        setSuggestions(accountNames);
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestions([]);
      }
    } else {
      setSuggestions([]);
    }
  }, [currentUrl, user]);
  // Fetch suggestions when the debounced query changes
  useEffect(() => {
    fetchSuggestions(debouncedQuery);
  }, [debouncedQuery, fetchSuggestions]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
  };

  const handleSuggestionClick = (suggestion) => {
    setSuggestions([]);
    setQuery('')
    const tab_name = 'accountPlan';
    const url = '/account_details/'+suggestion.id+'/'+suggestion.account_name+'/'+suggestion.client_name+"/?tab="+tab_name;
    window.location.replace(url);
  };

  const handleClickOutside = (e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setQuery('')
      setSuggestions([]);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className='search_box_v2_block' ref={wrapperRef}>
      <div className="search_box_v2">
       <i> <FeatherIcon.Search className='search_feather_v2'/></i>
        <input
          type="search"
          autoComplete='off'
          placeholder="Search"
          value={query}
          onChange={handleInputChange}
          className='search_input_v2'
        />
       
      </div>
      {suggestions.length > 0 && (
        <ul className="suggestions-list">
          {suggestions.map((item) => (

            <li key={item.id} onClick={() => handleSuggestionClick(item)}>
              {item.account_name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchBoxV2;
